var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "padlock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66667 6.99996V4.99996C4.66667 3.15863 6.15867 1.66663 8 1.66663C9.84133 1.66663 11.3333 3.15863 11.3333 4.99996V6.99996M12.6667 16.3333H3.33333C2.59733 16.3333 2 15.736 2 15V8.33329C2 7.59729 2.59733 6.99996 3.33333 6.99996H12.6667C13.4027 6.99996 14 7.59729 14 8.33329V15C14 15.736 13.4027 16.3333 12.6667 16.3333ZM10 11.6666C10 12.7713 9.10467 13.6666 8 13.6666C6.89533 13.6666 6 12.7713 6 11.6666C6 10.562 6.89533 9.66663 8 9.66663C9.10467 9.66663 10 10.562 10 11.6666Z",
    stroke: "#050922",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.65073f0120d08f8be4d9bda4d12bbbd4.svg";
export { ForwardRef as ReactComponent };